export function LoginPage() {
  return (
    <div className="login-screen">
      <h1>ごはんメモ</h1>
      <p>毎日のごはんと体重を、最速で。</p>
      <a className="btn-primary" href="/auth/google" style={{ minWidth: 240 }}>
        Google でログイン
      </a>
    </div>
  );
}
